import CartProductNew from './CartProductNew'

export default CartProductNew
